import React from 'react';
import { useWizard } from './WizardContext';
import { Table } from "react-bootstrap";
import LanguageToggle from "../LanguageToggle";
import { useGuestContext } from "../../../../contexts/GuestContext";
import lunarLampRight from "../../../../assets/img/baolinPrivate/lunarLampRight.png";
import lunarLampLeft from "../../../../assets/img/baolinPrivate/lunarLampLeft.png";
const Step3 = React.forwardRef((props, ref) => {
  const {
    firstname,
    lastname,
    chinesename,
    email,
    phone,
    event1,
    event2,
    headcountEvent1,
    headcountEvent2,
  } = useWizard();
  const { language } = useGuestContext();
  const isValidated = () => {
    return true;
  };

  React.useImperativeHandle(ref, () => ({
    isValidated: () => {
      return isValidated();
    },
  }));



  const getEventDisplayName = (eventNum) => {
    if (eventNum === 1) {
      return language === "English" 
        ? "Chinese Year-End blessing Ceremony"
        : "歲末祈福法會";
    } else if (eventNum === 2) {
      return language === "English"
        ? "Lunar New Year's Homage to the buddhas and great Patriarchs ceremony"
        : "新春合禮團拜法會";
    }
    return "";
  };

  const getSelectedEvents = () => {
    const events = [];
    if (event1) {
      events.push(getEventDisplayName(1));
    }
    if (event2) {
      events.push(getEventDisplayName(2));
    }
    return events.length > 0 ? events.join(", ") : (language === "English" ? "None selected" : "未選擇");
  };

  return (
    <div className="wizard-step">
      <p className="text-center mb-2 font-weight-bold">
        <img src={lunarLampLeft} alt="Company Logo" width="40" className="mr-3" />
        {language === "English" ? "Confirm your details" : "請確認所填信息無誤"}
        <img src={lunarLampRight} alt="Company Logo" width="40" className="ml-3" />
      </p>

      <hr />
      <LanguageToggle />
      <hr />
      <Table striped hover>
        <thead>
          <tr>
            <th>{language === "English" ? "Item" : "項目"}</th>
            <th className='d-flex justify-content-center align-items-center'>{language === "English" ? "Information" : "資料"}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{language === "English" ? "Selected Events" : "選擇的法會"}</td>
            <td className='d-flex justify-content-center text-center'>{getSelectedEvents()}</td>
          </tr>
          <tr>
            <td>{language === "English" ? "Full English Name" : "英文全名"}</td>
            <td className='d-flex justify-content-center text-center'>{firstname && lastname ? firstname + " " + lastname : (language === "English" ? "Not Provided" : "未填寫")}</td>
          </tr>
          <tr>
            <td>{language === "English" ? "Chinese Name" : "中文姓名"}</td>
            <td className='d-flex justify-content-center text-center'>{chinesename ? chinesename : (language === "English" ? "Not Provided" : "未填寫")}</td>
          </tr>
          <tr>
            <td>{language === "English" ? "Email Address" : "郵箱地址"}</td>
            <td className='d-flex justify-content-center text-center'>{email || (language === "English" ? "Not Provided" : "未填寫")}</td>
          </tr>
          <tr>
            <td>{language === "English" ? "Contact Phone" : "聯繫電話"}</td>
            <td className='d-flex justify-content-center text-center'>{phone || (language === "English" ? "Not Provided" : "未填寫")}</td>
          </tr>
          {event1 && (
            <tr>
              <td>{language === "English" 
                ? "Group Size for Chinese Year-End blessing Ceremony (People Coming Along and yourself)" 
                : "歲末祈福法會隨行人數（包括自己）"}</td>
              <td className='d-flex justify-content-center text-center'>
                {headcountEvent1 || (language === "English" ? "Not Provided" : "未填寫")}
              </td>
            </tr>
          )}
          {event2 && (
            <tr>
              <td>{language === "English" 
                ? "Group Size for Lunar New Year's Homage ceremony (People Coming Along and yourself)" 
                : "新春合禮團拜法會隨行人數（包括自己）"}</td>
              <td className='d-flex justify-content-center text-center'>
                {headcountEvent2 || (language === "English" ? "Not Provided" : "未填寫")}
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
});

export default Step3;
